export default class IdManager {
    constructor(prefix) {
        if (prefix.trim() === '') {
            throw new Error('Prefix must not be empty.');
        }
        this.counter = 1;
        this.prefix = prefix.trim();
    }
    getNextId() {
        this.counter++;
        return this.prefix + '-' + this.counter.toString();
    }
}
